import type { UserAuthProfile } from '@glyphic/user-api-types'

const ROLES_KEY = 'glyphicai-user-roles'
const PERMS_KEY = 'glyphicai-user-permissions'

export function readStoredUserRoles(): string[] {
  try {
    const raw = localStorage.getItem(ROLES_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : []
  } catch {
    return []
  }
}

export function readStoredUserPermissions(): string[] {
  try {
    const raw = localStorage.getItem(PERMS_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : []
  } catch {
    return []
  }
}

export function writeUserAuthorization(profile: Pick<UserAuthProfile, 'roles' | 'permissions'>): void {
  try {
    localStorage.setItem(ROLES_KEY, JSON.stringify(profile.roles ?? []))
    localStorage.setItem(PERMS_KEY, JSON.stringify(profile.permissions ?? []))
  } catch {
    /* ignore */
  }
}

export function clearUserAuthorization(): void {
  try {
    localStorage.removeItem(ROLES_KEY)
    localStorage.removeItem(PERMS_KEY)
  } catch {
    /* ignore */
  }
}
